import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'en' | 'es' | null;
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: 'en' | 'es') => void;
}
const LanguageContext = createContext<LanguageContextType>({
  language: null,
  setLanguage: () => {}
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>(null);
  const setLanguage = (lang: 'en' | 'es') => {
    localStorage.setItem('barber-lang', lang);
    setLanguageState(lang);
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-316">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}
export const TRANSLATIONS = {
  en: {
    eyebrow: "Hialeah's Most Trusted Barbershop",
    headline_line1: 'YOUR NEXT',
    headline_line2: 'FRESH CUT',
    headline_line3: 'IS ONE CLICK AWAY',
    subtext: 'Precision cuts, clean fades, and real craftsmanship — by barbers who actually care about how you look when you walk out that door.',
    walkins: 'Walk-Ins Welcome — Appointments Available',
    book_cta: 'BOOK YOUR APPOINTMENT',
    call_cta: 'CALL (786) 409-5863',
    address: '2851 W 68 St Suite 11, Hialeah Gardens, FL 33018',
    nav_services: 'Services',
    nav_about: 'About',
    nav_location: 'Location',
    nav_book: 'Book Now',
    services_eyebrow: 'What We Offer',
    services_headline: 'CUTS THAT SPEAK FOR THEMSELVES',
    services_subtext: 'Every service is delivered with precision, care, and the kind of attention to detail that keeps you coming back.',
    haircut_name: 'Classic Haircut',
    haircut_desc: 'Precision cut tailored to your style and face shape.',
    fade_name: 'Skin Fade',
    fade_desc: 'Razor-sharp fade from skin to length — clean every time.',
    beard_name: 'Beard Trim & Shape',
    beard_desc: 'Defined lines, clean edges, and a shape that fits your face.',
    shave_name: 'Hot Towel Shave',
    shave_desc: 'Old-school straight razor shave with hot towel treatment.',
    kids_name: "Kid's Cut",
    kids_desc: 'Patient, precise cuts for the little ones.',
    combo_name: 'Cut + Beard Combo',
    combo_desc: 'The full package — haircut and beard in one session.',
    testimonials_eyebrow: 'What Clients Say',
    testimonials_headline: 'REAL TALK FROM REAL CLIENTS',
    difference_eyebrow: "Why Jonathan's",
    difference_headline: 'THE DIFFERENCE IS IN THE DETAILS',
    location_eyebrow: 'Find Us',
    location_headline: 'COME SEE US',
    hours_title: 'Hours',
    mon_fri: 'Mon – Fri',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed',
    get_directions: 'Get Directions',
    finalcta_eyebrow: 'Ready for a Fresh Cut?',
    finalcta_headline: 'BOOK YOUR SPOT TODAY',
    finalcta_subtext: "Don't wait. Walk in or book ahead — we're ready for you.",
    finalcta_book: 'BOOK APPOINTMENT',
    finalcta_call: 'CALL NOW'
  },
  es: {
    eyebrow: 'La Barbería Más Confiable de Hialeah',
    headline_line1: 'TU PRÓXIMO',
    headline_line2: 'CORTE FRESCO',
    headline_line3: 'ESTÁ A UN CLIC',
    subtext: 'Cortes de precisión, fades limpios y artesanía real — por barberos que de verdad se preocupan por cómo sales por esa puerta.',
    walkins: 'Sin Cita Bienvenido — Citas Disponibles',
    book_cta: 'RESERVA TU CITA',
    call_cta: 'LLAMA (786) 409-5863',
    address: '2851 W 68 St Suite 11, Hialeah Gardens, FL 33018',
    nav_services: 'Servicios',
    nav_about: 'Nosotros',
    nav_location: 'Ubicación',
    nav_book: 'Reservar',
    services_eyebrow: 'Lo Que Ofrecemos',
    services_headline: 'CORTES QUE HABLAN POR SÍ SOLOS',
    services_subtext: 'Cada servicio se entrega con precisión, cuidado y la atención al detalle que te hace volver.',
    haircut_name: 'Corte Clásico',
    haircut_desc: 'Corte de precisión adaptado a tu estilo y forma de cara.',
    fade_name: 'Fade al Skin',
    fade_desc: 'Fade perfecto de piel a largo — limpio siempre.',
    beard_name: 'Arreglo de Barba',
    beard_desc: 'Líneas definidas, bordes limpios y una forma que te favorece.',
    shave_name: 'Afeitado con Toalla Caliente',
    shave_desc: 'Afeitado clásico con navaja recta y tratamiento de toalla caliente.',
    kids_name: 'Corte para Niños',
    kids_desc: 'Cortes pacientes y precisos para los más pequeños.',
    combo_name: 'Combo Corte + Barba',
    combo_desc: 'El paquete completo — corte y barba en una sola sesión.',
    testimonials_eyebrow: 'Lo Que Dicen los Clientes',
    testimonials_headline: 'PALABRAS REALES DE CLIENTES REALES',
    difference_eyebrow: "Por Qué Jonathan's",
    difference_headline: 'LA DIFERENCIA ESTÁ EN LOS DETALLES',
    location_eyebrow: 'Encuéntranos',
    location_headline: 'VEN A VERNOS',
    hours_title: 'Horario',
    mon_fri: 'Lun – Vie',
    saturday: 'Sábado',
    sunday: 'Domingo',
    closed: 'Cerrado',
    get_directions: 'Cómo Llegar',
    finalcta_eyebrow: '¿Listo para un Corte Fresco?',
    finalcta_headline: 'RESERVA TU LUGAR HOY',
    finalcta_subtext: 'No esperes. Entra sin cita o reserva — estamos listos para ti.',
    finalcta_book: 'RESERVAR CITA',
    finalcta_call: 'LLAMAR AHORA'
  }
};